/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-08-20 14:48:33
 * @LastEditors: game.pluto.com 66291979@qq.com
 * @LastEditTime: 2024-11-18 11:21:27
 * @FilePath: \lobby\src\common\airbridge.js
 * @Description:   https://help.airbridge.io/en/developers/web-sdk
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */

import airbridge from 'airbridge-web-sdk-loader'
import { AIRBRIDEG } from './config'

export const AIRBRIDEG_EVENT = {
  /** homeView事件*/
  VIEWED: 'airbridge.ecommerce.home.viewed',
  /** 完成注册*/
  SIGNUP: 'airbridge.user.signup',
  /** 登陆*/
  SIGNIN: 'airbridge.user.signin',
  /** 注销*/
  SIGNOUT: 'airbridge.user.signout',
  /** 加入购物车 */
  ADDED_TO_CART: 'airbridge.ecommerce.product.addedToCart',
  /** 订单文成 (充值完成) */
  ORDER_COMPLETED: 'airbridge.ecommerce.order.completed'
}

export const airbrideg_init = () => {
  const hash = window.location.href.split('#')[1]
  const pageParam = new URLSearchParams(hash)
  airbridge.init({
    app: AIRBRIDEG.APP_NAME[window.location.hostname],
    webToken: AIRBRIDEG.WEB_TOKEN,
    utmParsing: true,
    urlQueryMapping: {
      channel: pageParam.get('utm_source') || '',
      campaign: pageParam.get('utm_campaign') || '',
      sub_id: pageParam.get('utm_medium') || '',
      content: pageParam.get('utm_content') || '',
      term: pageParam.get('term') || ''
    }
  })
  console.log('airbridge.init:======>>>>>>', {
    app: AIRBRIDEG.APP_NAME[window.location.hostname] || 'vivagameet',
    webToken: AIRBRIDEG.WEB_TOKEN,
    utmParsing: true,
    urlQueryMapping: {
      channel: pageParam.get('utm_source') || '',
      campaign: pageParam.get('utm_campaign') || '',
      sub_id: pageParam.get('utm_medium') || '',
      content: pageParam.get('utm_content') || '',
      term: pageParam.get('term') || ''
    }
  })
}

export const airbrideg_report = (eventName, eventData) => {
  airbridge.events.send(eventName, eventData)
}
